module.exports = __webpack_public_path__ + "img/symbol_5.cd73e8f3.png";